import { mapToCamelCase } from '@consigli/utils';
import { z } from 'zod';
import { DocumentPackageType, documentPackageSchema } from './document-package';
import { languageSchema } from './language';
import { JobType } from './pipeline';
import { projectSchema } from './project';
export var ProcessorJobStatus;
(function (ProcessorJobStatus) {
    ProcessorJobStatus["INITIALIZED"] = "INITIALIZED";
    ProcessorJobStatus["STARTED"] = "STARTED";
    ProcessorJobStatus["FAILED"] = "FAILED";
    ProcessorJobStatus["COMPLETED"] = "COMPLETED";
    ProcessorJobStatus["STOPPED"] = "STOPPED";
})(ProcessorJobStatus || (ProcessorJobStatus = {}));
export const processorJobStatusSchema = z.nativeEnum(ProcessorJobStatus);
export const processorJobSchema = z
    .object({
    id: z.string().uuid(),
    project_id: projectSchema.innerType().shape.id,
    package_id: documentPackageSchema.innerType().shape.id,
    job_type: z.nativeEnum(JobType),
    package_type: z.nativeEnum(DocumentPackageType),
    secondary_package_id: documentPackageSchema.innerType().shape.id.nullish(),
    pipeline_name: z.string(),
    type: z.number().int(),
    created_at: z.string(),
    updated_at: z.string(),
    status: processorJobStatusSchema,
    language: languageSchema,
    metadata: z.record(z.string(), z.any()).nullish(),
})
    .strict()
    .transform(mapToCamelCase);
export const getProcessorJobsSchema = z.array(processorJobSchema).transform(mapToCamelCase);
export const getProcessorJobSchema = processorJobSchema;
